import React from 'react'
import moment from 'moment'
import {formatVosTravelTime} from './vosFormatters'
import {computeVosDurations, formatVosDurationMinutes, readOsiBreakTimeMinutes} from './vosDurationUtils'

type MeetingSummaryOsi = {
  startDate?: string
  endDate?: string
  breakTimeMinutes?: number | null
  isBreakTimeDeductionEnabled?: boolean
  milage?: number | null
  isRoundTrip?: boolean
  travalTimeH?: number | null
  travalTimeM?: number | null
}

const formatDuration = (start?: string, end?: string): string => {
  if (!start || !end) return '-'
  const minutes = moment(end).diff(moment(start), 'minutes')
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`
}

export const OSISubmissionDetailsCard: React.FC<{
  title: string
  meetingSummary: MeetingSummaryOsi
}> = ({title, meetingSummary}) => {
  const breakTimeMinutes = readOsiBreakTimeMinutes(meetingSummary as Record<string, unknown>)
  const {totalMinutes, netMinutes} = computeVosDurations(
    meetingSummary.startDate,
    meetingSummary.endDate,
    breakTimeMinutes,
    meetingSummary.isBreakTimeDeductionEnabled
  )

  return (
  <div className='card border rounded p-3'>
    <div className='fw-bold mb-3'>{title}</div>
    <span className='d-flex mb-2'>
      <i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
      <span className='me-2 fw-bold'>Start Time:</span>
      {meetingSummary.startDate ? moment(meetingSummary.startDate).format('hh:mm A') : '-'}
    </span>
    <span className='d-flex mb-2'>
      <i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
      <span className='me-2 fw-bold'>End Time:</span>
      {meetingSummary.endDate ? moment(meetingSummary.endDate).format('hh:mm A') : '-'}
    </span>
    <span className='d-flex mb-2'>
      <i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
      <span className='me-2 fw-bold'>Total Duration:</span>
      {formatVosDurationMinutes(totalMinutes)}
    </span>
    <span className='d-flex mb-2'>
      <i className='fa-solid fa-mug-hot me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
      <span className='me-2 fw-bold'>Break Time (mins):</span>
      {breakTimeMinutes != null ? breakTimeMinutes : '-'}
    </span>
    <span className='d-flex mb-2'>
      <i className='fa-solid fa-clock me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
      <span className='me-2 fw-bold'>Duration:</span>
      {formatVosDurationMinutes(netMinutes)}
    </span>
    <span className='d-flex mb-2'>
      <i className='fa-solid fa-car me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
      <span className='me-2 fw-bold'>Mileage Of Drive (miles):</span>
      {meetingSummary.milage != null ? meetingSummary.milage : '-'}
    </span>
    <span className='d-flex mb-2'>
      <i className='fa-solid fa-route me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
      <span className='me-2 fw-bold'>Round trip:</span>
      {meetingSummary.isRoundTrip ? 'Yes' : 'No'}
    </span>
    <span className='d-flex mb-2'>
      <i className='fa-solid fa-briefcase me-2 text-muted align-self-center' style={{fontSize: '12px'}} />
      <span className='me-2 fw-bold'>Travel Time:</span>
      {formatVosTravelTime(meetingSummary.travalTimeH, meetingSummary.travalTimeM)}
    </span>
  </div>
  )
}
